import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { buildSearchUrl } from '../../../../helpers/search';
import { getActiveLanguage } from '../../../../helpers/homepageUrl';

import CloseIcon from '../Icons/CloseIcon';
import SearchIcon from '../Icons/SearchIcon';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Cerca',
  },
  close: {
    id: 'Close',
    defaultMessage: 'Tancar',
  },
});

const SearchStrip = ({ isOpen, onClose }) => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(location.pathname, locale);
  const [text, setText] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const q = text?.trim();
    if (!q) return;
    history.push(buildSearchUrl(language, { SearchableText: q }));
    setText('');
    onClose();
  };

  return (
    <>
      <div
        className={`search-backdrop ${isOpen ? 'is-open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`search-overlay ${isOpen ? 'is-open' : ''}`}
        onClick={(ev) => ev.stopPropagation()}
        role="dialog"
        aria-label={intl.formatMessage(messages.search)}
      >
        <Container className="search-overlay__header">
          <button
            type="button"
            className="search-overlay__close"
            onClick={onClose}
            aria-label={intl.formatMessage(messages.close)}
          >
            <CloseIcon size={24} />
          </button>
        </Container>
        <div className="search-overlay__inner">
          <form
            className="search-overlay__form"
            onSubmit={handleSubmit}
            role="search"
          >
            <input
              ref={inputRef}
              type="search"
              className="search-overlay__input"
              placeholder={intl.formatMessage(messages.search)}
              value={text}
              onChange={(ev) => setText(ev.target.value)}
            />
            <button type="submit" className="search-overlay__submit">
              <SearchIcon size={36} />
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

SearchStrip.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SearchStrip;
